import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import { TcemsService  } from 'src/app/api/tcems.service';
import { MemberBenefits } from 'src/app/model/phi/member-benefits';
import { Phi } from 'src/app/model/phi/phi';
import { environment } from 'src/environments/environment';

const ELIGIBILITY_SOURCE_MAP: Record<number, string> = {
  1: 'HPHC',
  2: 'HPI',
  6: 'EBPA',
};

@Component({
  selector: 'app-eob-summary',
  templateUrl: './eob-summary.component.html',
  styleUrls: ['./eob-summary.component.scss']
})
export class EobSummaryComponent implements OnInit,OnChanges {

  constructor(
    private store: Store,
    private tcems: TcemsService,
    private sanitizer: DomSanitizer,
  ) {
  }

  @Input() phi: Phi;
  MemberBenefits: MemberBenefits;

  showEligibilityViewer = false;
  eligibilityIframeUrl?: SafeResourceUrl;

  get eligibilitySourceId(): string {
    const sourceId = this.phi?.company?.source?.sourceId;
    if (sourceId == null) return "null";
    return ELIGIBILITY_SOURCE_MAP[sourceId] ?? "null";
  }

  get canOpenEligibility(): boolean {
    return !!(this.eligibilitySourceId && this.phi?.memberId);
  }

  ngOnInit(): void
  {
    //this.instantiateEoB();  // This line causes the EDI API call to trigger twice
  }

  ngOnChanges(): void 
  {
    this.instantiateEoB();
  }


  instantiateEoB(): void
  {
    this.MemberBenefits = null;
    if (( this.phi.company?.tier1Id == -1) || ( this.phi.company?.tier1Id == -194)) {
      this.tcems.getEoB(this.phi.memberId).toPromise().then
      (
        sub => 
        {
          this.MemberBenefits = Object.assign(new MemberBenefits(), sub);
        }
      )//.catch ()
    } else {
      this.MemberBenefits = new MemberBenefits();
      this.MemberBenefits.active = false;
      this.MemberBenefits.hemiBenefitList = [];
      this.MemberBenefits.planDetails = {eligibilityStatus:'',startDate:null,endDate:null,typeCode:null,type:null,description:null,coverageBasis:null,serviceTypesSummary:null,summary:null};
    }
  }

  openEligibilityViewer(): void {
    if (!this.canOpenEligibility) return;

    const sourceId = encodeURIComponent(this.eligibilitySourceId);
    const memberId = encodeURIComponent(this.phi.memberId);
    const raw = `${environment.urlEligibilityViewer}/${sourceId}/${memberId}?showMenu=false`;
    this.eligibilityIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(raw);
    this.showEligibilityViewer = true;
  }

  onEligibilityViewerHide(): void {
    this.eligibilityIframeUrl = undefined;
  }
}
